import { SelectData } from "@king-ict/eupisi-ui/components";

import {
  InstitutionCodeBook,
  InstitutionCodeBookSearch,
} from "../../../models/Institution";
import { MzomAppeal } from "../../../models/Request";

export const MAX_MZOM_APPEAL_FILES = 1;
export const MAX_MZOM_APPEAL_TEXT_LENGTH = 50;

export const DEFAULT_APPEAL: MzomAppeal = {
  id: 0,
  requestId: 0,
  classification: "",
  associationNumber: "",
  enrolledInstitutionId: 0,
};

export const INSTITUTION_SEARCH_DEFAULTS: InstitutionCodeBookSearch = {
  onlyActive: false,
  includeOutsideEnrollmentArea: true,
  skipAuthorizationFilter: true,
};

export const EMPTY_INSTITUTION_SELECT_DATA: SelectData<InstitutionCodeBook> = {
  keyProp: "id",
  valueProp: "id",
  textProp: "name",
  data: [],
};
